export const getEstDate = (
  date?: Date,
  options?: Intl.DateTimeFormatOptions
) => {
  if (!date) return "";
  return date.toLocaleDateString("en-US", {
    ...options,
    timeZone: "America/New_York",
  });
};

export const getEstTime = (
  date?: Date,
  options?: Intl.DateTimeFormatOptions
) => {
  if (!date) return "";
  return date.toLocaleTimeString("en-US", {
    ...options,
    timeZone: "America/New_York",
  });
};

export const getEstDateTime = (
  date: Date,
  options?: { delimiter?: string } & Intl.DateTimeFormatOptions
) => {
  const { delimiter, ...dateOptions } = options || {};
  if (!date) return "";
  if (!delimiter)
    return `${getEstDate(date, dateOptions)} ${getEstTime(
      date,
      dateOptions
    )} EST`;
  return `${getEstDate(date, dateOptions)} ${delimiter} ${getEstTime(
    date,
    dateOptions
  )} EST`;
};

export const getTimeAgo = (date: Date): string => {
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffSeconds = Math.floor(diffMs / 1000);
  const diffMinutes = Math.floor(diffSeconds / 60);
  const diffHours = Math.floor(diffMinutes / 60);
  const diffDays = Math.floor(diffHours / 24);

  if (diffSeconds < 60) {
    return "just now";
  } else if (diffMinutes < 60) {
    return `${diffMinutes} minute${diffMinutes === 1 ? "" : "s"} ago`;
  } else if (diffHours < 24) {
    return `${diffHours} hour${diffHours === 1 ? "" : "s"} ago`;
  } else {
    return `${diffDays} day${diffDays === 1 ? "" : "s"} ago`;
  }
};
